const document = window.document
import { Message } from 'element-ui'
import axios from 'axios'
import i18n from '@/language/i18n'
export const utils = {
  hide: function (selectors) {
    let nodes = document.querySelectorAll(selectors)
    nodes.forEach(element => {
      element.style.display = 'none'
    })
  },
  /**
   * 获取按钮权限
   * @param index 按钮id下标
   * @param aType 账户所属公司类型户所属公司类型
   * @param adminButtons 运营权限按钮id集合
   * @param baseButtons 基地权限按钮id集合
   */
  buttonAuth: function (index, aType, adminButtons, pbButtons, PurchaseButtons) {
    let buttonIds = localStorage.getItem('button')
    if (buttonIds === null) {
      return false
    }
    let baseButtons = []
    if (aType === 1) { // 管理员
      baseButtons = adminButtons
    } else if (aType === 2) { // 代理商
      baseButtons = pbButtons
    } else if (aType === 3) { // 采购
      baseButtons = PurchaseButtons
    }
    let id = baseButtons[index]
    buttonIds = ',' + buttonIds + ','
    if (buttonIds.indexOf(',' + id + ',') >= 0) {
      return true
    } else {
      return false
    }
  },
  getUrlKey: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
  },
  // 复制
  copy: function (name, val) {
    var temp = document.createElement('textarea')
    temp.value = val
    document.body.appendChild(temp)
    temp.select()
    let currentFocus = document.activeElement
    if (document.execCommand('copy', true)) {
      setTimeout(() => {
        Message.success(name +' '+ i18n.t('Copied to paste board'))
      }, 10)
    }
    currentFocus.focus()
    document.body.removeChild(temp)
  },
  downBlobFile(url, query, callback) {
    return axios({
      url: url,
      method: 'post',
      responseType: 'blob',
      data: query
    }).then((response) => {
      let reader = new FileReader()
      reader.readAsText(response.data)
      reader.onload = function () {
        try {
          let res = JSON.parse(this.result)
          // 解析对象成功，说明是json数据
          if (res.code) {
            Message.error(res.msg)
          }
          callback()
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          let temp = response.headers['content-disposition']
            .split(';')[1]
            .split('filename=')[1] // 从返回头取出文件名称
          let fileNameStr = unescape(decodeURI(temp)) // 中文文件名需解码
          let fileName = fileNameStr.replace(/\\"/g, '').replace(/\\'/g, '')
          let blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          var link = document.createElement('a')
          document.body.appendChild(link)
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          // 释放内存
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
          callback()
        }
      }
    }).catch((error) => {
      Message.error(error.msg)
      callback()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/comn/js/utils.js